// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fbb10546","496":"44476e37","498":"984a704e","703":"a8f6b726"}[chunkId] + ".chunk.js";
};